import React from 'react'

const Furigana = ({children,reading}) => (<ruby>
  {children} <rp>(</rp><rt>{reading}</rt><rp>)</rp>
</ruby>)

export default Furigana